import userConstants from "../constants/userConstants";
import userService from "../services/userService";
import alertActions from "./alertActions";
import history from "../helpers/history";

const login = (username, password) => {
  const request = (user) => {
    return { type: userConstants.LOGIN_REQUEST, user };
  };
  const success = (user) => {
    return { type: userConstants.LOGIN_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: userConstants.LOGIN_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      (user) => {
        dispatch(success(user));
        dispatch(alertActions.success("Successfully logged in."));
        userService.verifyStaff().then((response) => {
          //console.log(response);
          if (response.status === 200) {
            history.push("/staff");
            return;
          }
          userService.verifyAttorney().then((attResponse) => {
            if (attResponse.status === 200) {
              history.push("/attorney");
              return;
            } else {
              history.push("/user");
              return;
            }
          });
        });
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error("There was an error logging you in. Make sure your username and password are correct."));
      }
    );
  };
};

const register = (
  dob,
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  phoneNumber
) => {
  const request = (registerApplicationUser) => {
    return {
      type: userConstants.REGISTER_REQUEST,
      registerApplicationUser,
    };
  };
  const success = (user) => {
    return { type: userConstants.REGISTER_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: userConstants.REGISTER_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(email));

    userService
      .register(
        dob,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        phoneNumber
      )
      .then(
        (user) => {
          dispatch(success(user));
          history.push("/user");
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };
};

const logout = () => {
  userService.logout();
  return { type: userConstants.LOGOUT };
};

const updateLogin = (user) => {
  const request = (user) => {
    return { type: userConstants.UPDATE_LOGIN_REQUEST, user };
  };
  const success = (user) => {
    return { type: userConstants.UPDATE_LOGIN_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: userConstants.UPDATE_LOGIN_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(user));

    userService.updateLogin(user).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const passwordReset = (newPassword) => {
  const request = (newPassword) => {
    return { type: userConstants.PASSWORD_RESET_REQUEST, newPassword };
  };
  const success = () => {
    return { type: userConstants.PASSWORD_RESET_SUCCESS };
  };
  const failure = (error) => {
    return { type: userConstants.PASSWORD_RESET_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request({ newPassword }));

    userService.resetPassword(newPassword).then(
      () => {
        dispatch(success());
        dispatch(login(newPassword.email, newPassword.password));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const confirmEmail = (token) => {
  const request = () => {
    return { type: userConstants.CONFIRM_EMAIL_REQUEST };
  };
  const success = () => {
    return { type: userConstants.CONFIRM_EMAIL_SUCCESS };
  };
  const failure = (error) => {
    return { type: userConstants.CONFIRM_EMAIL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    userService.confirmEmail(token).then(
      () => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const userActions = {
  login,
  logout,
  register,
  updateLogin,
  passwordReset,
  confirmEmail,
};

export default userActions;
